import { useEffect, useMemo, useState } from "react";

function normalizeHash() {
  const hash = window.location.hash.replace(/^#/, "");
  const path = hash.split("?")[0];
  return path.startsWith("/") ? path : "/";
}

export function useHashRoute() {
  const [path, setPath] = useState(normalizeHash);

  useEffect(() => {
    const onHashChange = () => setPath(normalizeHash());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return useMemo(
    () => ({
      path,
      navigate: (nextPath: string) => {
        window.location.hash = nextPath;
      }
    }),
    [path]
  );
}
